
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent }       from './login.component';

const LOGIN_ROUTES: Routes = [
  { path: 'Login', component: LoginComponent }
];

export const ROUTABLE_COMPONENTS = [
    LoginComponent
];

@NgModule({
  imports: [
    RouterModule.forChild(LOGIN_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class LoginRoutingModule {}
